import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Latin alphanumeric — the default pool for English and all non-JP portals.
const LATIN_POOL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
// Hiragana — used for the Japanese (jp) locale; more natural to read for
// Japanese users than Latin characters.
const HIRAGANA_POOL = 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわをん';

// Picks the character pool for the active language. A single generated
// captcha is always drawn from ONE pool — the alphabets never mix.
const poolForLanguage = (language) => (language === 'jp' ? HIRAGANA_POOL : LATIN_POOL);

const generateRandomString = (length, language) => {
    const characters = poolForLanguage(language);
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

const SimpleCaptcha = (props) => {

    const { t } = useTranslation();

    const [captchaText, setCaptchaText] = useState(() => generateRandomString(6, props.language));
    const [userInput, setUserInput] = useState('');
    const [isValid, setIsValid] = useState(null);
    const [isUserFilledCaptcha, setIsUserFilledCaptcha] = useState(false);

    // If the language changes after mount, regenerate so the captcha is
    // always drawn from the current language's pool (never a stale mix).
    useEffect(() => {
        setCaptchaText(generateRandomString(6, props.language));
        setUserInput('');
        setIsValid(null);
        props.onValid && props.onValid(false);
        props.updateCaptcha && props.updateCaptcha(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.language]);

    const regenerateCaptcha = () => {
        setCaptchaText(generateRandomString(6, props.language));
        setUserInput('');
        setIsValid(null);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setUserInput(value);
        if(value == ""){setIsUserFilledCaptcha(true)}else{setIsUserFilledCaptcha(false)}
        if(value.length < 1){setIsValid(null); props.onValid(false); return;}
        if (value === captchaText) {
            setIsValid(true);
            props.updateCaptcha(true);
            props.onValid(true);
        } else {
            setIsValid(false);
            props.updateCaptcha(false);
            props.onValid(false);
        }
    };

    return (
        <div style={{fontSize:`${window.matchMedia("(max-width: 768px)").matches ? "20px" : "16px"}`}}> 
            <div style={{borderRadius:"0.5rem", background:"#515356", color:"white", width:"8rem", textAlign:"center"}}> 
                {captchaText}
            </div>
            <input type="text" value={userInput} onChange={handleInputChange} className='mt-3 p-1' style={{border:"1px solid #999999",borderRadius:"0.75rem", width:"8rem", textAlign:"center"}}/>
            <button className="ml-2 text-white" type='button' onClick={regenerateCaptcha} style={{backgroundColor:"#046A38",borderRadius:"0.65rem"}}>{t('auth.captchaRegenerateButton')}</button>
            {isValid === true && <p style={{ color: 'green' }}>{t('auth.captchaValidMessage')}</p>}
            {isUserFilledCaptcha === true && <p style={{ color: 'red' }}>{t('auth.captchaEnterPrompt')}</p>}
            {isValid === false && <p style={{ color: 'red' }}>{t('auth.captchaInvalidMessage')}</p>}
        </div>
    );
};

SimpleCaptcha.propTypes = {
  onValid: PropTypes.func,
  updateCaptcha: PropTypes.func,
  language: PropTypes.string,
};

export default SimpleCaptcha;
